import $ from '@vaersaagod/tools/Dom';

export default el => {
    const radiobuttons = $(el).find('[type="radio"]');
    const buttons = $(el).find('[data-item-custom1-value]');

    const update = e => {
        buttons.attr('disabled', null).attr('data-item-custom1-value', e.target.value);
    };

    const init = () => {
        radiobuttons.on('change', update);
    };

    const destroy = () => {
        radiobuttons.off('change', update);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Product.js